var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { cx, css as emotionCss } from 'emotion';
import debounce from 'lodash/debounce';
import { Loader } from '@citrus/loader';
import { getAutomation, getDebug, getStyleNames, } from '@citrus/runtime';
import { getChildByType, getChildren, getChildrenByType, noEmptyChildrenDeep, overrideProps } from 'react-nanny';
import { commaString, findIndexes, isNotNullOrEmpty, get, has, removeKeys, iif } from '@pcty/utils';
import { columnFixedLeft, columnFixedRight, fixedLeftBorder, fixedRightBorder, headerFixedLeft, headerFixedRight, loadingContainer, wrapper, wrapperFixedLeft, wrapperFixedRight, wrapperScrollStart, wrapperScrollEnd, wrapperContainer, wrapperContainerScrollable, wrapperContainerScrollStart, wrapperContainerScrollEnd, } from '../styles/legacy';
import { columnFixedLeft as columnFixedLeftCitron, columnFixedRight as columnFixedRightCitron, fixedLeftBorder as fixedLeftBorderCitron, fixedRightBorder as fixedRightBorderCitron, headerFixedLeft as headerFixedLeftCitron, headerFixedRight as headerFixedRightCitron, loadingContainer as loadingContainerCitron, wrapper as wrapperCitron, wrapperFixedLeft as wrapperFixedLeftCitron, wrapperFixedRight as wrapperFixedRightCitron, wrapperScrollStart as wrapperScrollStartCitron, wrapperScrollEnd as wrapperScrollEndCitron, wrapperContainer as wrapperContainerCitron, wrapperContainerScrollable as wrapperContainerScrollableCitron, wrapperContainerScrollStart as wrapperContainerScrollStartCitron, wrapperContainerScrollEnd as wrapperContainerScrollEndCitron, tableLayoutFixed, } from '../styles/citron';
import { ActionAreaContainer, ActionAreaFooter, ActionAreaHeader, Table as Component, Container, FooterToolbar, LoadingContainer, PagerContainer, SelectedCountContainer, SelectedCountContainerDisabled, UpperToolbar, } from './Table.styled';
import { TableContext } from './private/TableContext';
import Th from './Th';
import Pager from './Pager';
import { WithTheme } from './private/WithTheme';
var VERSION = '6.12.2';
var _defaultProps = {
    disabled: false,
    equalColumnWidths: true,
    fixedHeader: false,
    fixedLeftColumns: 0,
    fixedRightColumns: 0,
    loading: false,
    lowerPager: true,
    pager: true,
    renderToolbar: function () { return undefined; },
    selectedCount: -1,
    upperPager: true,
    __TYPE: 'TableCore',
};
/** DISPLAY NAME: &lt;Table.Core&gt; */
var TableCore = /** @class */ (function (_super) {
    __extends(TableCore, _super);
    function TableCore(props) {
        var _this = _super.call(this, props) || this;
        _this.resizeDelay = debounce(function () {
            _this.checkScrollPosition();
            _this.getHeaderHeight();
            _this.getContainerdimensions();
            _this.pinLeftColumns();
            _this.pinRightColumns();
        }, 250);
        _this.getCss = function (legacy, citron) { var _a; return iif((_a = _this.props.theme) === null || _a === void 0 ? void 0 : _a.citrus2022, citron, legacy); };
        _this.state = {
            ids: {
                table: new Date().getTime().toString(),
                th: new Date().getTime().toString(),
            },
        };
        _this.refWrapper = React.createRef();
        _this.refContainer = React.createRef();
        _this.checkScrollPosition = _this.checkScrollPosition.bind(_this);
        _this.getHeaderHeight = _this.getHeaderHeight.bind(_this);
        _this.getContainerdimensions = _this.getContainerdimensions.bind(_this);
        _this.onResize = _this.onResize.bind(_this);
        _this.onScroll = _this.onScroll.bind(_this);
        _this.resizeDelay = _this.resizeDelay.bind(_this);
        return _this;
    }
    TableCore.prototype.componentDidMount = function () {
        var _a;
        window === null || window === void 0 ? void 0 : window.addEventListener('resize', this.onResize);
        (_a = this.refContainer.current) === null || _a === void 0 ? void 0 : _a.addEventListener('scroll', this.onScroll);
        this.checkScrollPosition();
        this.getHeaderHeight();
        this.getContainerdimensions();
        this.pinLeftColumns();
        this.pinRightColumns();
    };
    TableCore.prototype.componentDidUpdate = function () {
        this.checkScrollPosition();
        this.getHeaderHeight();
        this.getContainerdimensions();
        this.pinLeftColumns();
        this.pinRightColumns();
    };
    TableCore.prototype.componentWillUnmount = function () {
        var _a;
        window.removeEventListener('resize', this.onResize);
        (_a = this.refContainer.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', this.onScroll);
    };
    TableCore.prototype.onResize = function () {
        this.resizeDelay();
    };
    TableCore.prototype.onScroll = function () {
        this.checkScrollPosition();
    };
    TableCore.prototype.checkScrollPosition = function () {
        var _a, _b;
        if (!this.refContainer.current)
            return;
        try {
            var isAtTop = this.refContainer.current.scrollTop <= 0;
            if (isAtTop) {
                this.refContainer.current.classList.add(emotionCss(this.getCss(wrapperContainerScrollStart, wrapperContainerScrollStartCitron)));
            }
            else {
                this.refContainer.current.classList.remove(emotionCss(this.getCss(wrapperContainerScrollStart, wrapperContainerScrollStartCitron)));
            }
            var isAtBottom = this.refContainer.current.scrollTop >=
                this.refContainer.current.scrollHeight - this.refContainer.current.offsetHeight - 8;
            if (isAtBottom) {
                this.refContainer.current.classList.add(emotionCss(this.getCss(wrapperContainerScrollEnd, wrapperContainerScrollEndCitron)));
            }
            else {
                this.refContainer.current.classList.remove(emotionCss(this.getCss(wrapperContainerScrollEnd, wrapperContainerScrollEndCitron)));
            }
            if (!this.refWrapper.current)
                return;
            var isAtLeft = this.refContainer.current.scrollLeft <= 0;
            if (isAtLeft) {
                this.refWrapper.current.classList.add(emotionCss(this.getCss(wrapperScrollStart, wrapperScrollStartCitron)));
            }
            else {
                this.refWrapper.current.classList.remove(emotionCss(this.getCss(wrapperScrollStart, wrapperScrollStartCitron)));
            }
            var isAtRight = this.refContainer.current.scrollLeft >=
                this.refContainer.current.scrollWidth - this.refContainer.current.offsetWidth;
            if (isAtRight) {
                this.refWrapper.current.classList.add(emotionCss(this.getCss(wrapperScrollEnd, wrapperScrollEndCitron)));
            }
            else {
                this.refWrapper.current.classList.remove(emotionCss(this.getCss(wrapperScrollEnd, wrapperScrollEndCitron)));
            }
            var isOverflowing = this.refContainer.current.scrollWidth - this.refContainer.current.offsetWidth > 0;
            if (isOverflowing && ((_a = this.props.fixedLeftColumns) !== null && _a !== void 0 ? _a : 0) > 0) {
                this.refWrapper.current.classList.add(emotionCss(this.getCss(wrapperFixedLeft, wrapperFixedLeftCitron)));
            }
            else {
                this.refWrapper.current.classList.remove(emotionCss(this.getCss(wrapperFixedLeft, wrapperFixedLeftCitron)));
            }
            if (isOverflowing && ((_b = this.props.fixedRightColumns) !== null && _b !== void 0 ? _b : 0) > 0) {
                this.refWrapper.current.classList.add(emotionCss(this.getCss(wrapperFixedRight, wrapperFixedRightCitron)));
            }
            else {
                this.refWrapper.current.classList.remove(emotionCss(this.getCss(wrapperFixedRight, wrapperFixedRightCitron)));
            }
        }
        catch (error) {
            // do nothing
        }
    };
    TableCore.prototype.getHeaderHeight = function () {
        var _a;
        var element = (_a = this.refContainer.current) === null || _a === void 0 ? void 0 : _a.querySelector('th');
        if (!element || !this.refWrapper.current)
            return;
        var height = element.offsetHeight;
        this.refWrapper.current.style.setProperty('--header-height', height + 'px');
    };
    TableCore.prototype.getContainerdimensions = function () {
        var container = this.refContainer.current;
        if (!container || !this.refWrapper.current)
            return;
        var horizontalScrollbarHeight = container.offsetHeight - container.clientHeight;
        var verticalScrollWidth = container.offsetWidth - container.clientWidth;
        this.refWrapper.current.style.setProperty('--horizontal-scrollbar-height', horizontalScrollbarHeight + 'px');
        this.refWrapper.current.style.setProperty('--vertical-scrollbar-width', verticalScrollWidth + 'px');
        this.refWrapper.current.style.setProperty('--container-height', container.clientHeight + 'px');
        this.refWrapper.current.style.setProperty('--container-width', container.clientWidth + 'px');
    };
    TableCore.prototype.pinLeftColumns = function () {
        if (!this.refContainer.current ||
            !this.refWrapper.current ||
            !this.props.fixedLeftColumns ||
            this.props.fixedLeftColumns <= 0)
            return;
        var headers = this.refContainer.current.querySelectorAll('thead th');
        var rows = this.refContainer.current.querySelectorAll('tbody tr');
        var totalWidth = 0;
        var previousWidth = 0;
        for (var i = 0; i < this.props.fixedLeftColumns; ++i) {
            totalWidth += headers[i].clientWidth;
            if (i - 1 >= 0) {
                previousWidth += headers[i - 1].clientWidth;
            }
            if (i === this.props.fixedLeftColumns - 1) {
                headers[i].classList.add(emotionCss(this.getCss(fixedLeftBorder, fixedLeftBorderCitron)));
            }
            headers[i].classList.add(emotionCss(this.getCss(headerFixedLeft, headerFixedLeftCitron)));
            headers[i].style.setProperty('left', previousWidth + 'px');
        }
        for (var i = 0; i < rows.length; ++i) {
            var columns = rows[i].querySelectorAll('td');
            var previousWidth_1 = 0;
            for (var i_1 = 0; i_1 < this.props.fixedLeftColumns; ++i_1) {
                if (i_1 - 1 >= 0) {
                    previousWidth_1 += columns[i_1 - 1].clientWidth;
                }
                if (i_1 === this.props.fixedLeftColumns - 1) {
                    columns[i_1].classList.add(emotionCss(this.getCss(fixedLeftBorder, fixedLeftBorderCitron)));
                }
                columns[i_1].classList.add(emotionCss(this.getCss(columnFixedLeft, columnFixedLeftCitron)));
                columns[i_1].style.setProperty('left', previousWidth_1 + 'px');
            }
        }
        this.refWrapper.current.style.setProperty('--first-columns-width', totalWidth + 'px');
    };
    TableCore.prototype.pinRightColumns = function () {
        if (!this.refContainer.current ||
            !this.refWrapper.current ||
            !this.props.fixedRightColumns ||
            this.props.fixedRightColumns <= 0)
            return;
        var headers = this.refContainer.current.querySelectorAll('thead th');
        var rows = this.refContainer.current.querySelectorAll('tbody tr');
        var scrollBarWidth = this.refContainer.current.offsetWidth - this.refContainer.current.clientWidth;
        var totalWidth = 0;
        var previousWidth = 0;
        for (var i = headers.length - 1; i >= headers.length - this.props.fixedRightColumns; --i) {
            totalWidth += headers[i].clientWidth;
            if (i + 1 < headers.length) {
                previousWidth += headers[i + 1].clientWidth;
            }
            if (i === headers.length - this.props.fixedRightColumns) {
                headers[i].classList.add(emotionCss(this.getCss(fixedRightBorder, fixedRightBorderCitron)));
            }
            headers[i].classList.add(emotionCss(this.getCss(headerFixedRight, headerFixedRightCitron)));
            headers[i].style.setProperty('right', previousWidth + 'px');
        }
        for (var i = 0; i < rows.length; ++i) {
            var columns = rows[i].querySelectorAll('td');
            var previousWidth_2 = 0;
            for (var i_2 = columns.length - 1; i_2 >= columns.length - this.props.fixedRightColumns; --i_2) {
                if (i_2 + 1 < columns.length) {
                    previousWidth_2 += columns[i_2 + 1].clientWidth;
                }
                if (i_2 === columns.length - this.props.fixedRightColumns) {
                    columns[i_2].classList.add(emotionCss(this.getCss(fixedRightBorder, fixedRightBorderCitron)));
                }
                columns[i_2].classList.add(emotionCss(this.getCss(columnFixedRight, columnFixedRightCitron)));
                columns[i_2].style.setProperty('right', previousWidth_2 + 'px');
            }
        }
        this.refWrapper.current.style.setProperty('--last-columns-width', totalWidth + scrollBarWidth + 'px');
    };
    TableCore.prototype.render = function () {
        var _a, _b;
        var _c, _d, _e;
        var _f = this.props, automationId = _f.automationId, children = _f.children, loading = _f.loading, pager = _f.pager, renderState = _f.renderState, lowerPager = _f.lowerPager, upperPager = _f.upperPager;
        var disabled = this.props.disabled;
        disabled = loading ? true : disabled;
        var other = removeKeys(this.props, [
            'automationId',
            'children',
            'className',
            'css',
            'disabled',
            'equalColumnWidths',
            'fixedLeftColumns',
            'fixedHeader',
            'fixedRightColumns',
            'itemCount',
            'loading',
            'lowerPager',
            'onChangePage',
            'page',
            'pager',
            'pageSize',
            'renderState',
            'renderToolbar',
            'renderToolbarFooter',
            'renderZeroState',
            'selectedCount',
            'theme',
            'upperPager',
            '__TYPE',
        ]);
        var head = getChildByType(children, ['Thead']);
        var body = getChildByType(children, ['Tbody']);
        var hasData = true;
        var zeroState = undefined;
        var columns = isNotNullOrEmpty(head)
            ? getChildrenByType(head.props.children, ['Th', 'ThCheckbox']).length
            : 0;
        var headerGroups = isNotNullOrEmpty(head) ? getChildByType(head.props.children, ['ThGroups']) : undefined;
        var dividerIndexes = [];
        var renderGroups;
        var hiddenColumns = findIndexes(getChildrenByType(head.props.children, ['Th', 'ThCheckbox']), function (x) { var _a; return (_a = x === null || x === void 0 ? void 0 : x.props) === null || _a === void 0 ? void 0 : _a.hidden; });
        head = isNotNullOrEmpty(head)
            ? React.cloneElement(head, {
                children: getChildren(getChildrenByType(head.props.children, ['Th', 'ThCheckbox']), function (x) { var _a; return !((_a = x === null || x === void 0 ? void 0 : x.props) === null || _a === void 0 ? void 0 : _a.hidden); }),
            })
            : head;
        var expandable = [];
        var isDisabled = disabled !== null && disabled !== void 0 ? disabled : false;
        if (isNotNullOrEmpty(body) && has(body, 'props.children') && isNotNullOrEmpty(body.props.children)) {
            expandable = getChildrenByType(body.props.children, ['RowExpandable']);
            if (isNotNullOrEmpty(expandable)) {
                dividerIndexes = getGroupedHeaderDividerIndexes(headerGroups, true);
                body = processExpandableChildren(this.state.ids.table, expandable, isDisabled, columns);
            }
            else {
                dividerIndexes = getGroupedHeaderDividerIndexes(headerGroups);
                body = processBodyChildren(this.state.ids.table, body, isDisabled);
            }
        }
        else {
            hasData = false;
            zeroState = this.props.renderZeroState(isDisabled, renderState);
        }
        if (isNotNullOrEmpty(head)) {
            var children_1 = Array.isArray(head.props.children) ? head.props.children : [head.props.children];
            renderGroups = isNotNullOrEmpty(headerGroups) ? function () { return headerGroups; } : undefined;
            head = React.cloneElement(head, {
                children: isNotNullOrEmpty(expandable)
                    ? __spreadArray([
                        React.createElement(Th, { column: "expandable", css: { width: 48, padding: '0 !important' }, key: this.state.ids.th })
                    ], children_1, true) : children_1,
                disabled: disabled || isNotNullOrEmpty(zeroState) ? true : head.disabled,
            });
            if ((isNotNullOrEmpty(headerGroups) && disabled) || isNotNullOrEmpty(zeroState)) {
                headerGroups = overrideProps(headerGroups, function () { return ({ disabled: true }); });
            }
        }
        var emotionObj = (_a = {},
            _a[emotionCss(this.getCss(loadingContainer, loadingContainerCitron))] = hasData && loading,
            _a[emotionCss(this.props.css)] = isNotNullOrEmpty(this.props.css),
            _a);
        var classes = cx(emotionObj, this.props.className || '');
        var styleNames = {
            loadingContainer: (_c = emotionObj[emotionCss(this.getCss(loadingContainer, loadingContainerCitron))]) !== null && _c !== void 0 ? _c : false,
        };
        var context = {
            dividerIndexes: dividerIndexes,
            expandable: isNotNullOrEmpty(expandable),
            hiddenColumns: hiddenColumns,
            renderGroups: renderGroups,
            renderState: renderState,
        };
        var fixedLayout = this.props.fixedLeftColumns === 0 && this.props.fixedRightColumns === 0 && this.props.equalColumnWidths;
        var tableClasses = cx((_b = {}, _b[emotionCss(tableLayoutFixed)] = fixedLayout, _b));
        return (React.createElement(TableContext.Provider, { value: context },
            React.createElement(Container, __assign({ className: classes, styleNames: getStyleNames(styleNames) }, other, getAutomation(automationId), getDebug(sessionStorage.getItem('citrus-debug') === 'true', this.props.__TYPE, VERSION)),
                hasData && loading ? React.createElement(Loader, { loading: true }) : undefined,
                this.renderToolbar('upper', isNotNullOrEmpty(zeroState), UpperToolbar, ActionAreaHeader, (_d = (pager && upperPager)) !== null && _d !== void 0 ? _d : false),
                React.createElement("div", { className: emotionCss(this.getCss(wrapper, wrapperCitron)), ref: this.refWrapper },
                    React.createElement("div", { className: this.props.fixedHeader
                            ? emotionCss(this.getCss(wrapperContainerScrollable, wrapperContainerScrollableCitron))
                            : emotionCss(this.getCss(wrapperContainer, wrapperContainerCitron)), ref: this.refContainer },
                        React.createElement(Component, { className: tableClasses },
                            head,
                            body))),
                this.renderToolbar('lower', isNotNullOrEmpty(zeroState), FooterToolbar, ActionAreaFooter, (_e = (pager && lowerPager)) !== null && _e !== void 0 ? _e : false),
                !loading && zeroState,
                !hasData && this.renderLoader())));
    };
    TableCore.prototype.renderToolbar = function (type, zeroState, Toolbar, ActionArea, displayPager) {
        var _a, _b;
        if (zeroState)
            return React.createElement(React.Fragment, null);
        var pager = undefined;
        var size = (_a = this.props.pageSize) !== null && _a !== void 0 ? _a : 0;
        if (displayPager && (type === 'lower' || (type === 'upper' && this.props.itemCount > 10 && size > 10))) {
            pager = (React.createElement(PagerContainer, null,
                React.createElement(Pager, { automationId: get(getAutomation(this.props.automationId, "pager-".concat(type)), 'data-automation-id'), disabled: this.props.loading || this.props.disabled, itemCount: this.props.itemCount, onChangePage: this.props.onChangePage, page: this.props.page, pageSize: size <= 100 ? size : 100 })));
        }
        var disableToolbar = (_b = (this.props.loading || this.props.disabled)) !== null && _b !== void 0 ? _b : false;
        var toolbar = this.props.renderToolbar && (type === 'upper' || !this.props.renderToolbarFooter)
            ? this.props.renderToolbar(disableToolbar)
            : undefined;
        if (type === 'lower' && this.props.renderToolbarFooter) {
            var upper = this.props.renderToolbar && this.props.renderToolbar(disableToolbar);
            if (isNotNullOrEmpty(upper) && noEmptyChildrenDeep(upper, { rejectCustom: false })) {
                toolbar = this.props.renderToolbarFooter(disableToolbar);
            }
            else {
                // eslint-disable-next-line no-console
                console.error('\n********************\n Invalid Prop Usage\n********************\n\nProp: renderToolbarFooter (@citrus/data-table)\n\nYou may not use this prop when renderToolbar is undefined or returns anything other than a ReactNode. A table must always have an upper toolbar if you want a lower toolbar.');
            }
        }
        var selectedCount = this.renderSelectedCount();
        if (pager || toolbar || selectedCount) {
            return (React.createElement(Toolbar, null,
                React.createElement(ActionAreaContainer, null,
                    React.createElement(ActionArea, null, toolbar),
                    selectedCount),
                pager));
        }
        return React.createElement(React.Fragment, null);
    };
    TableCore.prototype.renderSelectedCount = function () {
        var _a;
        var selectedCount = (_a = this.props.selectedCount) !== null && _a !== void 0 ? _a : 0;
        if (selectedCount <= 0)
            return React.createElement(React.Fragment, null);
        var Component = this.props.disabled ? SelectedCountContainerDisabled : SelectedCountContainer;
        return (React.createElement(Component, null,
            React.createElement("b", null, "Selected:"),
            ' ',
            React.createElement("span", __assign({}, getAutomation(this.props.automationId, 'selected-count')), commaString(selectedCount))));
    };
    TableCore.prototype.renderLoader = function () {
        return this.props.loading ? (React.createElement(LoadingContainer, null,
            React.createElement(Loader, { loading: true }))) : (React.createElement(React.Fragment, null));
    };
    TableCore.defaultProps = _defaultProps;
    return TableCore;
}(React.Component));
var processBodyChildren = function (id, body, disabled) {
    return overrideProps(body, function (x, index) {
        if (index === void 0) { index = 0; }
        return ({
            disabled: disabled && !x.props.editing ? true : x.props.disabled,
            key: "data-table-".concat(id, "-").concat(index),
            __altByIndex: index % 2 !== 0,
        });
    });
};
var processExpandableChildren = function (id, expandable, disabled, columns) {
    return expandable.map(function (x, index) {
        return React.cloneElement(x, {
            columns: columns,
            disabled: disabled && !x.props.editing ? true : x.props.disabled,
            key: "data-table-".concat(id, "-").concat(index),
            __altByIndex: index % 2 !== 0,
        });
    });
};
var getGroupedHeaderDividerIndexes = function (headerGroups, expandable) {
    if (expandable === void 0) { expandable = false; }
    if (has(headerGroups, 'props.children')) {
        var indexes = [];
        var lastIndex = expandable ? -2 : -1;
        for (var _i = 0, _a = headerGroups.props.children; _i < _a.length; _i++) {
            var group = _a[_i];
            var index = lastIndex + group.props.colSpan;
            indexes = __spreadArray(__spreadArray([], indexes, true), [index], false);
            lastIndex = index;
        }
        return indexes.slice(0, indexes.length - 1);
    }
    return [];
};
export default WithTheme(TableCore);
